import $ from 'jquery';
import cursor from 'util/cursor';
import { jqOffOn } from 'util/global';
import analytics from 'util/analytics';

/**
 * returns startStr with newline char if needed
 */
const addNewline = ($input, cursorPosition, startStr) => {
  const inputText = $input.val();

  if (inputText && cursorPosition && !inputText.charAt(cursorPosition - 1).match(/\n/)) {
    return `\n${startStr}`;
  }

  return startStr;
};

/**
 * returns the text the user has highlighted/selected
 */
const getSelectedText = () => {
  let text = '';

  if (window.getSelection) {
    text = window.getSelection().toString();
  } else if (document.selection && document.selection.type !== 'Control') {
    ({ text } = document.selection.createRange());
  }

  return text;
};

/**
 * inserts appropriate markdown at cursor position
 * @param {object}
    {
        $input, {JQuery} - input element
        cursorPosition {number} - optional (will get from input if not specified)
        startStr, {string}
        endStr, {string}
        placeholderStr, {string}
    }
 */
const insertMarkdown = ({ $input, cursorPosition, startStr, endStr, placeholderStr }) => {
  let localCursorPosition;
  if (cursorPosition === undefined) {
    localCursorPosition = cursor.get($input);
  } else {
    localCursorPosition = cursorPosition;
  }
  const selectedText = getSelectedText();
  const selectedStartPos = localCursorPosition + startStr.length;
  let selectedEndPos;

  if (selectedText) {
    // TODO v2
    // check if selected text is already wrapped in markdown
    // if it is then remove the markdown

    selectedEndPos = selectedStartPos + selectedText.length;
    cursor.insert($input, startStr, localCursorPosition);
    cursor.insert($input, endStr, selectedEndPos);
  } else {
    selectedEndPos = selectedStartPos + placeholderStr.length;
    cursor.insert($input, startStr + placeholderStr + endStr, localCursorPosition);
  }

  cursor.set($input, selectedStartPos, selectedEndPos);

  $input.trigger('input');
};

/**
 * inserts appropriate markdown at cursor position
 * @param {JQuery} $input
 * @param {number} cursorPosition
 * @param {string} startStr
 * @param {string} endStr
 * @param {array} placeholders: array of placeholder objs, currently only two
 *      ex: [{startStr: '', placeholder: '', endStr: ''}, {startStr: '', placeholder: '', endStr: ''}]
 */
var insertMarkdownMultiplePlaceholders = function (
  $input,
  cursorPosition,
  startStr,
  endStr,
  placeholders,
) {
  var firstPlaceholderStartStr = placeholders[0].startStr,
    firstPlaceholderStr = placeholders[0].placeholder,
    firstPlaceholderEndStr = placeholders[0].endStr,
    secondPlaceholderStartStr = placeholders[1].startStr,
    secondPlaceholderStr = placeholders[1].placeholder,
    secondPlaceholderEndStr = placeholders[1].endStr,
    selectedText = getSelectedText(),
    selectedStartPos,
    selectedEndPos;

  if (selectedText) {
    // TODO v2
    // check if selected text is already wrapped in markdown
    // if it is then remove the markdown

    selectedStartPos =
      cursorPosition +
      startStr.length +
      firstPlaceholderStartStr.length +
      selectedText.length +
      firstPlaceholderEndStr.length +
      secondPlaceholderStartStr.length;
    selectedEndPos = selectedStartPos + secondPlaceholderStr.length;
    cursor.insert($input, startStr + firstPlaceholderStartStr, cursorPosition);
    cursor.insert(
      $input,
      firstPlaceholderEndStr +
        secondPlaceholderStartStr +
        secondPlaceholderStr +
        secondPlaceholderEndStr +
        endStr,
      cursorPosition + startStr.length + firstPlaceholderStartStr.length + selectedText.length,
    );
  } else {
    var selectedStr =
      firstPlaceholderStr +
      firstPlaceholderEndStr +
      secondPlaceholderStartStr +
      secondPlaceholderStr;
    selectedStartPos = cursorPosition + startStr.length + firstPlaceholderStartStr.length;
    selectedEndPos = selectedStartPos + selectedStr.length;
    cursor.insert(
      $input,
      startStr + firstPlaceholderStartStr + selectedStr + secondPlaceholderEndStr + endStr,
      cursorPosition,
    );
  }

  cursor.set($input, selectedStartPos, selectedEndPos);

  $input.trigger('input');
};

/**
 * Glossary modal for search and creation of glossary terms
 * glossaryModal -  is the html element for the modal
 * $inputForGlossary - is which input (question or solution) the modal was called from
 */
const $glossaryModal = $('.glossary-admin-modal');
let $inputForGlossary;

function glossaryModalInit() {
  $glossaryModal.modal('show');
  analytics.track('ui', {
    element_id: 'clicked_glossary_button',
    action: 'staff_only_action',
    element_type: 'btn',
  });

  function showNewGlossaryCardForm() {
    $glossaryModal.find('.new-glossary-card-container').removeClass('hide');
    import(/* webpackChunkName: "admin" */ '../../../admin/js/urlify.js').then(() => {
      // recreating the way the wiki name is turned into a slug in django admin
      $glossaryModal.find('#id_glossary_term').on('keyup', () => {
        const slug = $glossaryModal.find('#id_slug');
        slug.val(window.URLify($glossaryModal.find('#id_glossary_term').val(), 50));
      });
    });
    // recreating the search for wiki in the django admin
    const $filter = $glossaryModal.find('#id_filter_wiki');
    function filterWikiSelectOptions() {
      const $wiki = $glossaryModal.find('#id_wiki');
      const filterString = $filter.val().toLowerCase();
      if (filterString === '') {
        $wiki.find('option').css('display', 'block');
      } else {
        $wiki.find('option').each((index, el) => {
          const $el = $(el);
          if (
            $el.html().toLowerCase().indexOf(filterString) !== -1 ||
            $el.val().indexOf(filterString) !== -1
          ) {
            $el.css('display', 'block');
          } else {
            $el.css('display', 'none');
          }
        });
      }
    }
    $filter.on('keyup', filterWikiSelectOptions);
  }

  function searchGlossaryTerms(e) {
    analytics.track('ui', {
      element_id: 'search_glossary_term',
      action: 'staff_only_action',
      element_type: 'btn',
    });
    e.preventDefault();
    const $glossaryList = $glossaryModal.find('.search-glossary-card-container');
    $.get(e.target.href, { prefix: $glossaryModal.find('.prefix').val() }).then(response => {
      const html = response
        .map(
          el => `<li><button data-value="${el.value}"
                    class="btn-link">${el.name}</button></li>`,
        )
        .join('');
      $glossaryList.html(html);
      $glossaryList.find('button').on('click', event => {
        insertMarkdown({
          $input: $inputForGlossary,
          startStr: $(event.target).data('value').split(']]')[0],
          endStr: ']]',
          placeholderStr: '',
        });
        $glossaryModal.modal('hide');
        analytics.track('ui', {
          element_id: 'add_searched_glossary_term',
          action: 'staff_only_action',
          element_type: 'link',
        });
      });
    });
  }
  jqOffOn($glossaryModal.find('.new-glossary-card'), 'click', showNewGlossaryCardForm);
  jqOffOn($glossaryModal.find('.search-glossary'), 'click', searchGlossaryTerms);
}

export function newGlossaryTerm($newGlossaryTerm) {
  insertMarkdown({
    $input: $inputForGlossary,
    startStr: $newGlossaryTerm.html().split(']]')[0],
    endStr: ']]',
    placeholderStr: '',
  });
  $glossaryModal.modal('hide');
  $newGlossaryTerm.remove();
  analytics.track('ui', {
    element_id: 'add_new_glossary_term',
    action: 'staff_only_action',
    element_type: 'btn',
  });
}

/**
 * handles text formatting bar events
 * @param {JQuery} $bar
 */
export function controller($bar) {
  var data = $bar.data(),
    $btns = $bar.find('.btn'),
    $latexBtn = $btns.filter('.add-latex'),
    $linkBtn = $btns.filter('.add-link'),
    $imageBtn = $btns.filter('.add-image'),
    $exampleBtn = $btns.filter('.add-example'),
    $proofBtn = $btns.filter('.add-proof'),
    $glossaryBtn = $btns.filter('.add-glossary'),
    $boldBtn = $btns.filter('.add-bold'),
    $fractionBtn = $btns.filter('.add-fraction'),
    $listBtn = $btns.filter('.add-list'),
    $tableBtn = $btns.filter('.add-table'),
    $input = $(data.target);

  var buttonEvents = function () {
    $btns.on('mousedown', function (e) {
      e.preventDefault();
    });

    // add latex
    $latexBtn.on('click', function (e) {
      e.preventDefault();

      var cursorPosition = cursor.get($input),
        startStr = '\\(',
        placeholderStr = 'LaTeX',
        endStr = '\\)';

      insertMarkdown({ $input, cursorPosition, startStr, endStr, placeholderStr });
    });

    // add link
    $linkBtn.on('click', function (e) {
      e.preventDefault();

      var cursorPosition = cursor.get($input),
        startStr = '',
        endStr = '',
        placeholders = [
          {
            startStr: '[',
            placeholder: 'link text',
            endStr: ']',
          },
          {
            startStr: '(',
            placeholder: 'https://brilliant.org',
            endStr: ')',
          },
        ];

      insertMarkdownMultiplePlaceholders($input, cursorPosition, startStr, endStr, placeholders);
    });

    // add image
    // widen the clickable area of the button
    $imageBtn.on('click', function (e) {
      if (e.target === this) {
        $imageBtn.find('input').trigger('click');
      }
    });

    // add example (wiki only)
    $exampleBtn.on('click', function (e) {
      e.preventDefault();

      var cursorPosition = cursor.get($input),
        startStr = addNewline($input, cursorPosition, '[[start-example]]'),
        endStr = '[[end-example]]',
        placeholderStr = 'example text';

      insertMarkdown({ $input, cursorPosition, startStr, endStr, placeholderStr });
    });

    // add proof (wiki only)
    $proofBtn.on('click', function (e) {
      e.preventDefault();

      var cursorPosition = cursor.get($input),
        startStr = addNewline($input, cursorPosition, '[[start-proof]]'),
        endStr = '[[end-proof]]',
        placeholderStr = 'proof text';

      insertMarkdown({ $input, cursorPosition, startStr, endStr, placeholderStr });
    });

    // add glossary reference (solvable only)
    $glossaryBtn.on('click', e => {
      e.preventDefault();
      $inputForGlossary = $input;
      glossaryModalInit();
    });

    // add bold text
    $boldBtn.on('click', function (e) {
      e.preventDefault();

      var cursorPosition = cursor.get($input),
        startStr = '**',
        endStr = '**',
        placeholderStr = 'bold text';

      insertMarkdown({ $input, cursorPosition, startStr, endStr, placeholderStr });
    });

    // add fraction latex
    $fractionBtn.on('click', function (e) {
      e.preventDefault();

      var cursorPosition = cursor.get($input),
        startStr = '\\(\\frac',
        endStr = '\\)',
        placeholders = [
          {
            startStr: '{',
            placeholder: 'numerator',
            endStr: '}',
          },
          {
            startStr: '{',
            placeholder: 'denominator',
            endStr: '}',
          },
        ];

      insertMarkdownMultiplePlaceholders($input, cursorPosition, startStr, endStr, placeholders);
    });

    // add list
    $listBtn.on('click', function (e) {
      e.preventDefault();

      var inputText = $input.val(),
        cursorPosition = cursor.get($input),
        lineStartPos = inputText.lastIndexOf('\n', cursorPosition - 1) + 1,
        lineEndPos = inputText.indexOf('\n', cursorPosition - 1),
        bulletMarkdown = '- ',
        selectedText = getSelectedText(),
        newCursorPosition = cursorPosition;

      lineEndPos = lineEndPos == -1 ? inputText.length : lineEndPos;
      if (inputText.slice(lineStartPos, lineEndPos).search(bulletMarkdown) == -1) {
        // there is no bullet on the current line
        // so add a bullet
        // and update the cursor position to account for the added bullet
        cursor.insert($input, bulletMarkdown, lineStartPos);
        newCursorPosition += bulletMarkdown.length;
      }

      if (selectedText) {
        cursor.set($input, newCursorPosition, newCursorPosition + selectedText.length);
      } else {
        cursor.set($input, newCursorPosition);
      }

      $input.trigger('input');

      // TODO v2
      // add bullet on every subsequent new line
    });

    // add table
    $tableBtn.on('click', function (e) {
      e.preventDefault();

      var cursorPosition = cursor.get($input),
        startStr = addNewline($input, cursorPosition, '||'),
        endStr = '||',
        placeholders = [
          {
            startStr: '',
            placeholder: 'row 1 col 1||row 1 col 2',
            endStr: '||\n',
          },
          {
            startStr: '||',
            placeholder: 'row 2 col 1||row 2 col 2',
            endStr: '',
          },
        ];

      insertMarkdownMultiplePlaceholders($input, cursorPosition, startStr, endStr, placeholders);
    });
  };

  if ($input.length) {
    buttonEvents();
  } else {
    $(data.target.replace('__copy', '')).on('mentions.ready', function () {
      $input = $(data.target);
      buttonEvents();
    });
  }
}
